import { tv } from "../../variants/tv.js";
const discGroupVariants = tv({
    slots: {
        baseSlot: 'flex items-center',
        discSlot: ''
    },
    variants: {
        size: {
            '2xs': {},
            xs: {},
            sm: {},
            md: {},
            lg: {}
        },
        isVertical: {
            true: {
                baseSlot: 'flex flex-col items-center',
                discSlot: '-mt-2'
            },
            false: {
                discSlot: '-ml-2'
            }
        }
    },
    compoundVariants: [
        {
            size: '2xs',
            isVertical: true,
            class: {
                discSlot: '-mt-1'
            }
        },
        {
            size: '2xs',
            isVertical: false,
            class: {
                discSlot: '-ml-1'
            }
        }
    ],
    defaultVariants: {
        size: 'md',
        isVertical: false
    }
});
export { discGroupVariants };
